import { useSelector } from 'react-redux';
import { getUserRole } from '@mssgme/store';

export function useAccessControl() {
    const role = useSelector(getUserRole);

    function hasAccess(...allowedRoles) {
        return allowedRoles.includes(role);
    }

    const isAdmin = hasAccess('owner', 'admin');
    const isOwner = hasAccess('owner');
    const isManager = hasAccess('manager');

    return { hasAccess, role, isAdmin, isOwner, isManager };
}
